import { dataLockSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLockSolid = /*#__PURE__*/createIcon(dataLockSolid)
export default IconLockSolid
